import { ServiceConfirmationStyle } from '@features/components/CaseCard/Blocks/Confirmation/constants';
import { SpecialistCssTypes } from '@features/components/CaseCard/Blocks/Base/types';

export enum SpecialistStylesStyle {
  base = 'base',
  minor = 'minor',
}

export const specialistCssStyles: Record<ServiceConfirmationStyle, SpecialistCssTypes> = {
  [SpecialistStylesStyle.base]: {
    role: 'text-m-m',
    fullName: 'text-base-20',
    rightIconSize: 16,
  },
  [SpecialistStylesStyle.minor]: {
    role: 'text-s-r font-medium',
    fullName: 'text-base-10',
    rightIconSize: 24,
  },
};
